module.exports = __webpack_public_path__ + "img/s10.db342ce.png";